import React from 'react';
import { motion } from 'framer-motion';
import './GallerySection.css';

// --- ALL 38 IMPORTS ---
import img2 from '../../assets/Images/gallery2.jpeg';
import img3 from '../../assets/Images/gallery3.jpeg';
import img4 from '../../assets/Images/gallery4.jpeg';
import img5 from '../../assets/Images/gallery5.jpeg';
import img6 from '../../assets/Images/gallery6.jpeg';
import img7 from '../../assets/Images/gallery7.jpeg';
import img8 from '../../assets/Images/gallery8.jpeg';
import img9 from '../../assets/Images/gallery9.jpeg';
import img10 from '../../assets/Images/gallery10.jpeg';
import img11 from '../../assets/Images/gallery11.jpeg';
import img12 from '../../assets/Images/gallery12.jpeg';
import img13 from '../../assets/Images/gallery13.jpeg';
import img14 from '../../assets/Images/gallery14.jpeg';
import img15 from '../../assets/Images/gallery15.jpeg';
import img16 from '../../assets/Images/gallery16.jpeg';
import img17 from '../../assets/Images/gallery17.jpeg';
import img18 from '../../assets/Images/gallery18.jpeg';
import img19 from '../../assets/Images/gallery19.jpeg';
import img20 from '../../assets/Images/gallery20.jpeg';
import img21 from '../../assets/Images/gallery21.jpeg';
import img22 from '../../assets/Images/gallery22.jpeg';
import img23 from '../../assets/Images/gallery23.jpeg';
import img24 from '../../assets/Images/gallery24.jpeg';
import img25 from '../../assets/Images/gallery25.jpeg';
import img26 from '../../assets/Images/gallery26.jpeg';
import img27 from '../../assets/Images/gallery27.jpeg';
import img28 from '../../assets/Images/gallery28.jpeg';
import img29 from '../../assets/Images/gallery29.jpeg';
import img30 from '../../assets/Images/gallery30.jpeg';
import img31 from '../../assets/Images/gallery31.jpeg';
import img32 from '../../assets/Images/gallery32.jpeg';
import img33 from '../../assets/Images/gallery33.jpeg';
import img34 from '../../assets/Images/gallery34.jpeg';
import img35 from '../../assets/Images/gallery35.jpeg';
import img36 from '../../assets/Images/gallery36.jpeg';
import img37 from '../../assets/Images/gallery37.jpeg';
import img38 from '../../assets/Images/gallery38.jpeg';


const GallerySection = () => {
  // Mapping images to an array for the loop
  const galleryImages = [
    { id: 1, title: "Spiti Expedition", loc: "Himachal", tag: "Adventure", img: img2 },
    { id: 2, title: "Shimla Heights", loc: "Himachal", tag: "Luxury", img: img3 },
    { id: 3, title: "Manali Sanctuary", loc: "Himachal", tag: "Spiritual", img: img4 },
    { id: 4, title: "Jibhi Hideout", loc: "Himachal", tag: "Hidden Gem", img: img5 },
    { id: 5, title: "Rohtang Pass", loc: "Himachal", tag: "Snow", img: img6 },
    { id: 6, title: "Kasol Vibes", loc: "Himachal", tag: "Nature", img: img7 },
    { id: 7, title: "Dalhousie View", loc: "Himachal", tag: "Heritage", img: img8 },
    { id: 8, title: "Bir Billing", loc: "Himachal", tag: "Flying", img: img9 },
    { id: 9, title: "Khajjiar Meadows", loc: "Himachal", tag: "Greenery", img: img10 },
    { id: 10, title: "Key Monastery", loc: "Spiti", tag: "Peace", img: img11 },
    { id: 11, title: "Chitkul Village", loc: "Kinnaur", tag: "Border", img: img12 },
    { id: 12, title: "Solang Valley", loc: "Manali", tag: "Fun", img: img13 },
    { id: 13, title: "Kaza Market", loc: "Spiti", tag: "Local", img: img14 },
    { id: 14, title: "Tirthan Valley", loc: "Himachal", tag: "Riverside", img: img15 },
    { id: 15, title: "Dharamshala", loc: "Himachal", tag: "Yoga", img: img16 },
    { id: 16, title: "Sissu Lake", loc: "Lahaul", tag: "Blue", img: img17 },
    { id: 17, title: "Baralacha La", loc: "Himachal", tag: "High", img: img18 },
    { id: 18, title: "Himalayan Tea", loc: "Palampur", tag: "Fields", img: img19 },
    { id: 19, title: "McLeod Ganj", loc: "Himachal", tag: "Monks", img: img20 },
    { id: 20, title: "Sangla Valley", loc: "Kinnaur", tag: "Apples", img: img21 },
    { id: 21, title: "Malana Trek", loc: "Himachal", tag: "Ancient", img: img22 },
    { id: 22, title: "Prashar Lake", loc: "Mandi", tag: "Magic", img: img23 },
    { id: 23, title: "Old Manali", loc: "Himachal", tag: "Cafes", img: img24 },
    { id: 24, title: "Kufri Snow", loc: "Shimla", tag: "Winter", img: img25 },
    { id: 25, title: "Hatu Peak", loc: "Narkanda", tag: "Peak", img: img26 },
    { id: 26, title: "Beas River", loc: "Himachal", tag: "Rafting", img: img27 },
    { id: 27, title: "Naddi View", loc: "Dharamshala", tag: "Sunset", img: img28 },
    { id: 28, title: "Jogini Falls", loc: "Manali", tag: "Trek", img: img29 },
    { id: 29, title: "Kalpa View", loc: "Kinnaur", tag: "Kailash", img: img30 },
    { id: 30, title: "Chandratal", loc: "Spiti", tag: "Moon Lake", img: img31 },
    { id: 31, title: "Pin Valley", loc: "Himachal", tag: "Wild", img: img32 },
    { id: 32, title: "Mall Road", loc: "Shimla", tag: "Walk", img: img33 },
    { id: 33, title: "Vashisht Bath", loc: "Manali", tag: "Hot Springs", img: img34 },
    { id: 34, title: "Naggar Castle", loc: "Kullu", tag: "History", img: img35 },
    { id: 35, title: "Great Himalayan", loc: "Kullu", tag: "UNESCO", img: img36 },
    { id: 36, title: "Khardung La", loc: "Ladakh", tag: "Motorcycle", img: img37 },
    { id: 37, title: "Komic Village", loc: "Spiti", tag: "Highest", img: img38 },
    
  ];

  // Seamless looping ke liye data ko double kiya
  const doubledData = [...galleryImages, ...galleryImages];

  return (
    <section className="Premium-Gallery">
      <div className="gallery-head-wrapper">
        <motion.span 
          className="sub-heading-orange"
          initial={{ opacity: 0, scale: 0.3 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0.2 }}
        >
          HIMACHAL SPECIALS
        </motion.span>
        
        <motion.h1 
          className="main-gallery-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
        >
          Real Experiences <span>Real Smiles</span>
        </motion.h1>

        <motion.div 
          className="title-underline"
          initial={{ width: 0 }}
          whileInView={{ width: "80px" }}                   
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
        ></motion.div>
      </div>

      <div className="gallery-viewport">
        <motion.div 
          className="gallery-track-left-to-right"
          animate={{ x: ["-50%", "0%"] }} 
          transition={{ 
            duration: 20, // Fast energetic motion
            repeat: Infinity, 
            ease: "linear",
          }}
          whileHover={{ animationPlayState: "paused" }}
          style={{ display: 'flex', gap: '25px' }}
        >
          {doubledData.map((item, index) => (
            <div key={index} className="luxury-card">
              <img src={item.img} alt={item.title} loading="lazy" />
              <div className="luxury-overlay">
                <div className="overlay-top">
                  <span className="category-tag">{item.tag}</span>
                </div>
                <div className="overlay-bottom">
                  <h3>{item.title}</h3>
                  <p><i className="fas fa-map-marker-alt"></i> {item.loc}</p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default GallerySection;